import { useState } from "react";
import styles from "../../styles/PantallaDeProgramasAcademicos.v2.module.css";
import NuevoDocenteModal from "./NuevoDocenteModal";
import { getTeacher, updateTeacher, deleteTeacher } from "../../api/teachers";
import { usePermissions } from '../../hooks/usePermissions';

const ActionButtons = ({ teacherId }) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("Nuevo Asesor");
  const [readOnly, setReadOnly] = useState(false);
  const [initialForm, setInitialForm] = useState(null);

  // PERMISOS
  const { canEdit, canDelete } = usePermissions();
  const puedeEditar = canEdit('Perfil Académico');
  const puedeEliminar = canDelete('Perfil Académico');

  // getTeacher ya devuelve el formato correcto para el modal
  // No necesitamos mapear de nuevo, solo pasar los datos directamente

  const handleView = async () => {
    try {
      const data = await getTeacher(teacherId);
      console.log('[ActionButtons] Datos para ver:', data);
      setInitialForm(data); // getTeacher ya mapea al formato del modal
      setTitle("Ver Asesor");
      setReadOnly(true);
      setOpen(true);
    } catch (e) {
      console.error("Error al cargar docente", e);
      alert("No se pudo cargar el docente");
    }
  };

  const handleEdit = async () => {
    try {
      const data = await getTeacher(teacherId);
      console.log('[ActionButtons] Datos para editar:', data);
      setInitialForm(data); // getTeacher ya mapea al formato del modal
      setTitle("Editar Asesor");
      setReadOnly(false);
      setOpen(true);
    } catch (e) {
      console.error("Error al cargar docente", e);
      alert("No se pudo cargar el docente");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("¿Eliminar este asesor? Esta acción no se puede deshacer.")) return;
    try {
      await deleteTeacher(teacherId);
      window.dispatchEvent(new CustomEvent('docente:changed'));
      window.dispatchEvent(new CustomEvent('toast:show', { detail: { type: 'success', message: 'Asesor eliminado correctamente' } }));
    } catch (e) {
      console.error("Error al eliminar docente", e);
      window.dispatchEvent(new CustomEvent('toast:show', { detail: { type: 'error', message: 'No se pudo eliminar el asesor' } }));
    }
  };

  return (
    <>
      <div className={styles.actionButtons}>
        <button className={styles.actionButton} aria-label="Ver detalles" onClick={handleView}>
          <img
            src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/a1782ac5b190a9d29d8f798383eedda3f294d56b?placeholderIfAbsent=true"
            alt="Ver"
            className={styles.actionIcon}
          />
        </button>
        {puedeEditar && (
          <button className={styles.actionButton} aria-label="Editar" onClick={handleEdit}>
            <img
              src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/83eacec9f1f974b33615bbc95aea7ff7b2d13b0e?placeholderIfAbsent=true"
              alt="Editar"
              className={styles.actionIcon}
            />
          </button>
        )}
        {puedeEliminar && (
          <button className={styles.actionButton} aria-label="Eliminar" onClick={handleDelete}>
            <img
              src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/bef20ed4bd5293db48e37df8e511dca0fed7db2e?placeholderIfAbsent=true"
              alt="Eliminar"
              className={styles.actionIcon}
            />
          </button>
        )}
        {!puedeEditar && !puedeEliminar && (
          <span style={{ color: '#888', fontSize: '12px' }}>Solo lectura</span>
        )}
      </div>

      {/* Reusar el modal para ver/editar con datos iniciales; modo lectura deshabilita campos */}
      {open && (
        <NuevoDocenteModal
          open={open}
          onClose={() => setOpen(false)}
          onSubmit={async (form) => {
            try {
              await updateTeacher(teacherId, form);
              window.dispatchEvent(new CustomEvent('docente:changed'));
              window.dispatchEvent(new CustomEvent('toast:show', { detail: { type: 'success', message: 'Asesor actualizado' } }));
              setOpen(false);
            } catch (e) {
              console.error('Error al actualizar docente', e);
              window.dispatchEvent(new CustomEvent('toast:show', { detail: { type: 'error', message: 'No se pudo actualizar el asesor' } }));
            }
          }}
          /* props extra reconocidas por el modal (se agregan a continuación) */
          title={title}
          readOnly={readOnly}
          initialForm={initialForm}
        />
      )}
    </>
  );
};

export default ActionButtons;
